import React from 'react'
import { TextField } from '@material-ui/core'

export const SelectInput = ({
  input,
  label,
  meta: { touched, error },
  children,
  ...custom
}) => (
  <TextField
    select
    label={label}
    error={Boolean(touched && error)}
    helperText={Boolean(touched && error) && helperText}
    SelectProps={{
      native: true
    }}
    {...input}
    {...custom}
  >
    {children}
  </TextField>
)



// WEBPACK FOOTER //
// ./src/components/SelectInput/SelectInput.js